"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureToggleSettingsProvider = function (_React$PureComponent) {
  (0, _inherits3.default)(FeatureToggleSettingsProvider, _React$PureComponent);

  function FeatureToggleSettingsProvider() {
    (0, _classCallCheck3.default)(this, FeatureToggleSettingsProvider);
    return (0, _possibleConstructorReturn3.default)(this, (FeatureToggleSettingsProvider.__proto__ || Object.getPrototypeOf(FeatureToggleSettingsProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeatureToggleSettingsProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        featureToggleSettings: this.props.featureToggleSettings
      };
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.Children.only(this.props.children);
    }
  }]);
  return FeatureToggleSettingsProvider;
}(_react2.default.PureComponent);

FeatureToggleSettingsProvider.childContextTypes = {
  featureToggleSettings: _propTypes2.default.object.isRequired
};
exports.default = FeatureToggleSettingsProvider;